import { Component, Element, h, Host, Prop, State } from "@stencil/core";

const baseClass = "ux-tab-switcher";

@Component({
    tag: "ux-tab-switcher",
    styleUrl: "tab-switcher.scss",
    shadow: false
})
export class TabSwitcher {
    @Element() element!: HTMLUxTabSwitcherElement;
    /** identifier of the targeted tab */
    @Prop() readonly tabId: string = "";
    /** set custom tab color;
     * currently available colors: grey */
    @Prop() readonly tabColor: string = "";
    /** Removes border from tab button if set to true */
    @Prop() readonly noBorder: boolean = false;
    /** define appearance of ux-tab-switcher */
    @Prop() readonly type: "button" | "link" = "button";
    private tabContainer: HTMLUxTabContainerElement | null = null;
    private radioBtn: HTMLUxRadioButtonElement | null = null;
    /** shows the button as activated - this should be in sync with the tab */
    @State() active = false;

    componentWillLoad() {
        if (this.tabId === "") {
            return;
        }
        // @ts-expect-error Check for typing
        this.tabContainer = document
            .querySelector(`ux-tab[tab-id=${this.tabId}]`)
            .closest("ux-tab-container") as HTMLUxTabContainerElement;
        this.active = this.tabContainer.activeTabId === this.tabId;
        this.tabContainer.addEventListener("uxActiveTabSet", (e) => {
            this.active = (e as CustomEvent).detail === this.tabId;
        });
        this.radioBtn = this.element.querySelector("ux-radio-button") as HTMLUxRadioButtonElement;
    }

    componentWillUpdate() {
        if (this.radioBtn !== null && this.radioBtn !== undefined) {
            this.radioBtn.checked = this.active;
        }
    }
    render() {
        return (
            <Host
                class={{
                    [`${baseClass}`]: true,
                    [`${baseClass}--link ux-text-link ux-text-link--green`]: this.type === "link",
                    [`${baseClass}--${this.tabColor}`]: this.tabColor !== "",
                    [`${baseClass}--no-border`]: this.noBorder,

                    ["ux-button"]: this.type === "button",
                    ["ux-button--toggle"]: this.type === "button" && !this.active,
                    ["ux-button--toggle-active"]: this.type === "button" && this.active
                }}
                onClick={() => {
                    if (this.tabContainer === null || this.tabId === "") {
                        return;
                    }
                    this.tabContainer.setActiveTab(this.tabId);
                }}
            >
                <slot />
            </Host>
        );
    }
}
